import { render, staticRenderFns } from "./GroupAddressList.vue?vue&type=template&id=03529f3c&scoped=true"
import script from "./GroupAddressList.vue?vue&type=script&lang=ts"
export * from "./GroupAddressList.vue?vue&type=script&lang=ts"
import style0 from "./GroupAddressList.vue?vue&type=style&index=0&id=03529f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03529f3c",
  null
  
)

export default component.exports